<h1 mat-dialog-title *ngIf="dialogTitle">{{ dialogTitle }}</h1>
<mat-dialog-content>
  <ng-container *ngIf="dialogType === 'BusinessManager' || dialogType === 'FlyingClubManager'">
    <p>You can edit the details on this page by enabling "Edit Mode" using the slider button located above the
      {{ prettyType }} name.</p>

    <p>Each editable section will have a blue pencil icon next to it.  Clicking on the pencil icon will display
      options for updating, adding new or removing details in that section.
    </p>

    <p>If you need further assistance, please contact us at:</p>
    <p>AOPA Airport Directory Support Team:<br>
      Email: <a href="mailto:airportdirectory@aopa.org">airportdirectory@aopa.org</a><br>
      Phone: <a href="tel:1-888-359-2672">(888) 359-2672</a>
    </p>
  </ng-container>
  <ng-container *ngIf="dialogType === 'ClaimManager'">
    <p>If you manage this business and have not claimed it yet, please click the "Claim Business" button
      below to begin the process.  If you have previously claimed this business, make sure you are logged into
      aopa.org to be able to edit the business listing.</p>

    <p>If you need further assistance, please contact us at:</p>
    <p>AOPA Airport Directory Support Team:<br>
      Email: <a href="mailto:airportdirectory@aopa.org">airportdirectory@aopa.org</a><br>
      Phone: <a href="tel:1-888-359-2672">(888) 359-2672</a>
    </p>
  </ng-container>
  <ng-container *ngIf="dialogType === 'ReportIssue'">
    <p>If you would like to suggest a change to the information on this page, we'll be happy to verify the details
      and update as needed.  Please contact us at:</p>

    <p>AOPA Airport Directory Support Team:<br>
      Email: <a href="mailto:airportdirectory@aopa.org">airportdirectory@aopa.org</a><br>
      Phone: <a href="tel:1-888-359-2672">(888) 359-2672</a>
    </p>

    <p>Be sure to include a link to the page you are requesting changes on as well as specific details about the
    requested change.</p>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
  <button *ngIf="dialogType && dialogType === 'ClaimManager'" class="mat-raised-button"
          (click)="goToLink('https://www.aopa.org/travel/destinations/update-fbo-listing/submit-FBO')">Claim Business</button>
  <button id="cancelButton" class="mat-raised-button submit-button" (click)="cancel()">Close</button>
</mat-dialog-actions>
